import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import ChartActions
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/AllocationAnalysisActions/ChartActions';

const ChartActionsPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.runAnalysis.name]: () => {
      return (
        <ChartActions {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default ChartActionsPicker;
